document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartFooter', () => {
    return {
      footerRoot: null,
      _morphFooter(e) {
        const newFooterSection = querySelectorInHTMLString(
          '[data-cart-footer]',
          e.detail.response.sections['cart-footer']
        );

        Alpine.morph(
          this.footerRoot,
          newFooterSection ? newFooterSection.outerHTML : '',
          {
            updating(el, toEl, childrenOnly, skip) {
              if (
                el.classList &&
                el.classList.contains('additional-checkout-buttons')
              ) {
                skip();
              }
            },
          }
        );
      },
      _setupCheckoutInterception() {
        // Use event delegation to handle dynamically updated buttons
        this.submitButton = this.$root.querySelector(
          '#CartSubmitButton'
        );

        if (this.submitButton) {
          this.submitButton.addEventListener('click', (e) => {
            e.preventDefault();
            console.log("redirecting to PayPal checkout");
            window.location.href = '/pages/paypal-checkout';
          });
        }
      },
      init() {
        this.footerRoot = this.$root;
          
        window.addEventListener('cascade:modalcart:afteradditem', (e) => {
          this._morphFooter(e);
        });

        window.addEventListener('cascade:modalcart:cartqtychange', (e) => {
          this._morphFooter(e);
        });
      },
    };
  });
});
